/**
 * Returns the internal `[[Class]]` tag of a value.
 *
 * This is a reliable way to detect built-in object types and boxed primitives.
 *
 * @param value - The value to inspect.
 * @returns A string tag in the format `[object Type]`.
 *
 * @example
 * getObjectTag(true); // "[object Boolean]"
 * getObjectTag(new Number(42)); // "[object Number]"
 * getObjectTag([]); // "[object Array]"
 */
export function getObjectTag(value: unknown): string {
  return Object.prototype.toString.call(value);
}
